// Gallery arrow navigation for desktop thumbnail_slider layout.
// On desktop, non-active slides have display:none so SliderComponent's
// scrollLeft approach computes NaN. Override to use media-gallery's own API.
(function () {
  function initGalleryNav() {
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    const viewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    const prevBtn = viewer.querySelector('.slider-button--prev');
    const nextBtn = viewer.querySelector('.slider-button--next');
    if (!prevBtn || !nextBtn) return;

    function getSlides() {
      // querySelectorAll on the ul, not the slider-component, to avoid
      // picking up any nested [data-media-id] inside thumbnail sliders
      const ul = viewer.querySelector('[id^="Slider-Gallery"]');
      if (!ul) return [];
      return Array.from(ul.children).filter((el) => el.dataset.mediaId);
    }

    function getActiveIndex() {
      const slides = getSlides();
      const idx = slides.findIndex((s) => s.classList.contains('is-active'));
      return idx >= 0 ? idx : 0;
    }

    function goTo(index) {
      const slides = getSlides();
      if (!slides.length) return;
      index = ((index % slides.length) + slides.length) % slides.length;
      const mediaId = slides[index].dataset.mediaId;

      // Call media-gallery's public method directly to avoid click side-effects
      if (typeof mediaGallery.setActiveMedia === 'function') {
        mediaGallery.setActiveMedia(mediaId, false);
      }
    }

    // Intercept in capture phase before SliderComponent's bubble-phase handler
    prevBtn.addEventListener('click', function (e) {
      if (window.innerWidth < 750) return;
      e.stopImmediatePropagation();
      goTo(getActiveIndex() - 1);
    }, true);

    nextBtn.addEventListener('click', function (e) {
      if (window.innerWidth < 750) return;
      e.stopImmediatePropagation();
      goTo(getActiveIndex() + 1);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryNav);
  } else {
    initGalleryNav();
  }
})();
